// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"lh","centerLink":"mh","productSection":"nh","item":"oh","ctaButton":"ph"};